import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentTypeChecking: {
        id: 'endorsement.directives.templates.bank-account-details.Checking',
        defaultMessage: 'Checking',
    },
    paymentTypeSavings: {
        id: 'endorsement.directives.templates.bank-account-details.Savings',
        defaultMessage: 'Savings',
    },
    paymentOptions: {
        id: 'quoteandbind.views.payment-details.Payment Options',
        defaultMessage: 'Payment Options',
    },
    averageMonthlyPremium: {
        id: 'quoteandbind.views.payment-details.Average Monthly Premium',
        defaultMessage: 'Average Monthly Premium:',
    },
    paymentDetails: {
        id: 'quoteandbind.views.payment-details.Payment Details',
        defaultMessage: 'Payment Details',
    },
    totalPremium: {
        id: 'quoteandbind.views.payment-details.Total Premium:',
        defaultMessage: 'Total Premium:',
    },
    paymentBuyNow: {
        id: 'quoteandbind.views.payment-details.submit',
        defaultMessage: 'Submit',
    },
    paymentPlanText: {
        id: 'twia.quoteandbind.views.payment-details.PaymentPlansReadText',
        defaultMessage: 'Please note that depending on the reason for policy cancellation, TWIA may be required by law to keep the full annual premium.'
    },
    additionalMessagePF: {
        id: 'twia.quoteandbind.views.payment-details.AdditionalInterestOtherPrem',
        defaultMessage: 'A Premium Finance Company must be added as an Additional Interest on the '
    },
    additionalMessageMortgagee:{
        id: 'twia.quoteandbind.views.payment-details.AdditionalInterestMortgagee',
        defaultMessage: 'A Mortgagee must be added as an Additional Interest on the '
    },
    installmentPopupTitle: {
        id: "twia.quoteandbind.residential.views.installmentsPopupHeader",
        defaultMessage: "Proposed Payment Schedule"
    },
    mortgagee: {
        id: "twia.quoteandbind.residential.views.mortgagee",
        defaultMessage: "Mortgagee"
    },
    pfCompany: {
        id: "twia.quoteandbind.residential.views.pfCompany",
        defaultMessage: "Premium Finance Company"
    },
    pfMessage: {
        id: "twia.quoteandbind.residential.views.pfMessage",
        defaultMessage: "Please refer to your Premium Finance Agreement for all agreement-related details. Finance charges or fees are not included in the amount quoted by TWIA."
    },
    tenPayMsg: {
        id: "twia.quoteandbind.residential.views.tenPayMsg",
        defaultMessage: "This payment plan requires the policyholder to enroll in Auto Pay in the Policyholder Portal. A valid policyholder email address is required for the policyholder to receive enrollment information and billing notifications for this plan. If Auto Pay is not setup, the policy will default to a 4-Pay plan without written notice to you or the policyholder."
    },
    validEmail:{
        id: "twia.quoteandbind.residential.views.validEmail",
        defaultMessage: "A valid policyholder email address is required to select the TWIA 10 Pay (Auto Pay) plan."
    },
    invalidBank: {
        id: 'twia.gateway.views.selfservice.pay.Bad Bank Info Title',
        defaultMessage: 'Invalid Bank Information'
    },
    badBank: {
        id: 'twia.gateway.views.selfservice.pay.badBank',
        defaultMessage: 'The routing or account information is incorrect. Please retype valid information.'
    },
    paymentThreshold: {
        id: "twia.quoteandbind.residential.views.paymentThreshold",
        defaultMessage: "Payment Threshold Exceeded",
    },
    paymentThresholdMsg: {
        id: "twia.quoteandbind.residential.views.paymentThresholdMsg",
        defaultMessage: "Payment amount must be between $3.00 - $99,999.00",
    },
    paymentThresholdMsgR352: {
        id: "twia.quoteandbind.residential.views.paymentThresholdMsgR352",
        defaultMessage: "Payment amount must be between $3.00 - $500,000.00",
    },
    confirmTransaction: {
        id: "twia.quoteandbind.residential.views.confirmTransaction",
        defaultMessage: "Confirm Transaction",
    },
    confirmTransactionMsg: {
        id: "twia.quoteandbind.residential.views.confirmTransactionMsg",
        defaultMessage: "This transaction cannot be modified after it has been submitted. Do you want to continue?",
    },
    validate10PayEmail: {
        id: "twia.quoteandbind.residential.views.validate10PayEmail",
        defaultMessage: "A valid policyholder email address is required to select the TWIA 10 Pay (Auto Pay) plan.",
    },
    commercialMortgageMessage: {
        id: "twia.quoteandbind.cp.views.commercialMortgageMessage",
        defaultMessage: "A Mortgagee must be added as an Additional Interest within the Building Additional Interest screen."
    },
    commercialPfMessage: {
        id: "twia.quoteandbind.cp.views.commercialPfMessage",
        defaultMessage: "A Premium Finance Company must be added on the "
    },
    uwPolicyHold_twia: {
        id: 'twia.quoteandbind.cp.views.A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.',
        defaultMessage: 'A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.',
    },
    uwOtherBlockingIssue_twia: {
        id: 'twia.quoteandbind.cp.views."Underwriting issues have been raised for this transaction.',
        defaultMessage: 'Underwriting issues have been raised for this transaction.',
    },
    unableToProcessPayment: {
        id: "twia.quoteandbind.payment.error.We are unable to process your payment at this time. Please contact TWIA Agent Services at (800) 788-8247",
        defaultMessage: "We are unable to process your payment at this time. Please contact TWIA Agent Services at (800) 788-8247",
    },
    policyholderEmailRequired: {
        id: 'twia.quoteandbind.residential.views.A valid policyholder email address is required',
        defaultMessage: 'A valid policyholder email address is required because the account/policy is registered with the Policyholder Portal.',
    },
    required: {
        id: 'twia.quoteandbind.Payment.This is a required field.',
        defaultMessage: 'This is a required field.',
    },
    emailValidationMessage: {
        id: 'twia.quoteandbind.Payment.Email.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
});
